import * as rutHelpers from 'rut-helpers';
import event from './Event';

export default function(el, binding) {
	// Enfoca el elemento
	if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
		var els = el.getElementsByTagName('input')
		if (els.length !== 1) {
			throw new Error("v-mask directive requires 1 input, found " + els.length)
		} else {
			el = els[0]
		}
	}

	el.oninput = function (evt) {
		// verifica si el input es enviado por interaccion del usuario
		// para evitar loops infinitos
		if (!evt.isTrusted) return;

		const oldValue = el.value;
		// formatea el rut
		const newValue = rutHelpers.rutFormat(el.value) || '';
		// en caso de que el elemento html necesite ser actualizado 
		// con el rut formateado se dispara un evento 'input'
		if (oldValue !== newValue) {
			el.value = rutHelpers.rutFormat(el.value).replace(/\./g,'') || '';
			el.value.toLocaleUpperCase();
			el.dispatchEvent(event('input'))
		}
	}

}